export const meta: BlockMeta = {
  title: "Testimonial",
  tags: ["#page", "#inline"],
}

import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/testimonial", (props) => {
  return (
    <Appear className="content-sized block-spacing relative flex items-start justify-start">
      <InnerBlocks
        className={cn(
          "w-full flex flex-col gap-4 [&_h5]:!type-mobile-headings-heading-l  [&_h5]:md:!type-desktop-headings-heading-l [&_h5]:md:!max-w-[65%] [&_p]:!type-desktop-body-body-s [&_*]:!my-0",
        )}
        allowedBlocks={["core/heading", "core/paragraph"]}
        template={[
          ["core/heading", { placeholder: "Add large text here...", level: 5 }],
          ["core/paragraph", { placeholder: "Add small text here..." }],
        ]}
      />
    </Appear>
  )
})
